export const stats = [
  {
    value: 12,
    prefix: '1:',
    suffix: '',
    label: 'Historical ROI Benchmark',
    decimals: 0,
  },
  {
    value: 500,
    prefix: '$',
    suffix: 'K+',
    label: 'Record Month Revenue',
    decimals: 0,
  },
  {
    value: 200,
    prefix: '',
    suffix: '%',
    label: 'Above Campaign Goal',
    decimals: 0,
  },
  {
    value: 2.5,
    prefix: '',
    suffix: 'x',
    label: 'Average Lead Growth',
    decimals: 1,
  },
];

export const dfyFeatures = [
  'Marketing strategy',
  'Lead generation',
  'Paid ads',
  'CRM + automations',
  'Funnel optimization',
  'Follow-up systems',
  'Reporting & improvement',
];

export const dwyFeatures = [
  'Marketing audits',
  'Growth strategy',
  'Team guidance',
  'Campaign review',
  'Systems optimization',
  'Lead flow analysis',
  'Ongoing consulting',
];

export const leadsSystem = [
  {
    letter: 'L',
    title: 'Look & Audit',
    desc: 'Review your current marketing, lead flow, follow-up, tracking, and sales process to identify gaps and growth opportunities.',
  },
  {
    letter: 'E',
    title: 'Establish Foundation',
    desc: 'Build the tracking, messaging, offers, landing pages, and core systems needed to turn marketing into measurable results.',
  },
  {
    letter: 'A',
    title: 'Automate Systems',
    desc: 'Automate lead capture, follow-up, nurturing, and key workflows so opportunities do not fall through the cracks.',
  },
  {
    letter: 'D',
    title: 'Dial in Paid Ads',
    desc: 'Launch and optimize targeted paid campaigns focused on qualified leads, customer acquisition, and measurable return.',
  },
  {
    letter: 'S',
    title: 'Scale and Organic Growth',
    desc: 'Scale what is working while strengthening organic visibility, referrals, content, and long-term growth channels.',
  },
];

export const whoFor = [
  {
    icon: 'ri-building-2-line',
    title: 'Established Home-Service Businesses',
    desc: 'Businesses with existing traction that are ready to build a more predictable and measurable growth system.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Roofing, HVAC & Hardscape/Landscape',
    desc: 'Josh’s primary focus is helping roofing, HVAC, and hardscape or landscape businesses improve lead generation and growth.',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '$300,000+ in Annual Revenue',
    desc: 'Built for companies doing $300,000 or more annually and ready to invest in stronger marketing systems.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Owners Focused on Measurable Growth',
    desc: 'Business owners who want marketing tied to leads, customers, revenue, and clear performance data.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Teams That Want Better Lead Follow-Up',
    desc: 'Businesses that want stronger systems for capturing, nurturing, following up with, and converting leads.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Businesses Ready to Scale',
    desc: 'Companies looking to strengthen paid acquisition, automation, organic growth, and long-term marketing systems.',
  },
];

export const caseStudies = [
  {
    tag: 'Roofing',
    result: '200% Above Goal',
    context:
      'A residential roofing company was spending on ads with inconsistent results and no clear way to track ROI.',
    outcome:
      'Doubled booked appointments while cutting cost per lead by 40% in the first 90 days.',
    quote:
      'We finally know exactly what our marketing dollars are doing. The pipeline is predictable now.',
    author: 'Owner, Midwest Roofing Co.',
  },
  {
    tag: 'HVAC',
    result: '$500K+ Record Month',
    context:
      'An established HVAC company wanted to scale beyond word-of-mouth referrals during peak season.',
    outcome:
      'Drove a record month with over $500K in revenue from a rebuilt lead and follow-up system.',
    quote:
      'Josh rebuilt our follow-up and turned missed calls into booked service. It changed our whole season.',
    author: 'Founder, Residential HVAC',
  },
  {
    tag: 'Hardscaping',
    result: '$550K Month',
    context:
      'A hardscaping business had great work but struggled to keep a steady pipeline of high-value projects.',
    outcome:
      'Built a predictable pipeline that generated a $550K month without adding more ad spend.',
    quote:
      'We stopped chasing jobs and started choosing them. The quality of leads is night and day.',
    author: 'Owner, Outdoor Living Co.',
  },
];

export const testimonials = [
  {
    quote:
      'Josh is not a typical marketer. He thinks like a business owner and measures everything in revenue, not impressions.',
    name: 'Daniel R.',
    role: 'Owner, Residential Roofing',
  },
  {
    quote:
      'The numbers on paper were one thing — the actual results were even better. We hit the benchmark within months.',
    name: 'Sarah M.',
    role: 'GM, HVAC Company',
  },
  {
    quote:
      'From strategy to execution, he made our internal team look better and our numbers prove it.',
    name: 'Mike T.',
    role: 'Founder, Hardscaping Co.',
  },
  {
    quote:
      'Clear, honest, and results-driven. Josh told us what would work, what would not, and delivered on the rest.',
    name: 'Lauren K.',
    role: 'Co-owner, Home Services',
  },
];
